import React, { FC, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { SideMenuItemProps } from './types'

const SideMenuItem: FC<SideMenuItemProps> = (props) => {
  const navigate = useNavigate()

  // 現在のpathと子アイテムのpathを比較して、一致するものがあれば初期表示時に開く
  const [isOpen, setIsOpen] = useState(() => {
    const currentPath = window.location.pathname
    return props.items.some((item) => item.path === currentPath)
  })

  // サイドメニューが閉じている時
  if (!props.sideMenuIsOpen) {
    return (
      <div className="flex items-center relative py-2 px-3">
        <span className="material-icons !text-xl">{props.icon}</span>
      </div>
    )
  }

  const handleClickParent = () => {
    if (props.path) {
      navigate(props.path)
    } else {
      setIsOpen(!isOpen)
    }
  }

  // 子アイテムの最大高さを計算（アニメーションに使用）
  const childrenHeight = props.items.length * 50 // 各アイテムの高さを50pxと仮定

  return (
    <>
      <div
        className="flex items-center relative py-2 px-2 cursor-pointer hover:opacity-50 transition-all"
        onClick={handleClickParent}
      >
        <span className="material-icons !text-xl">{props.icon}</span>
        {props.sideMenuIsOpen && (
          <div className="pl-2 text-base font-semibold">{props.label}</div>
        )}
        {props.items.length > 0 && (
          <span
            className={`material-icons absolute right-4 top-2 !text-2xl transition-transform duration-300 ease-out ${
              isOpen ? 'rotate-90' : 'rotate-180'
            }`}
          >
            navigate_next
          </span>
        )}
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ease-out bg-main-lightgray`}
        style={{
          maxHeight: isOpen ? `${childrenHeight}px` : '0px',
        }}
      >
        <div className="pt-2 pb-3">
          {props.items.map((item, index) => (
            <>
              {item.path && (
                <Link
                  className="py-2 pl-9 pr-2 block text-base font-semibold"
                  to={item.path}
                  key={`side_menu_item_path_${index}`}
                >
                  {item.label}
                </Link>
              )}
              {item.onClick && (
                <div
                  className="py-2 pl-9 pr-2 block text-base font-semibold"
                  onClick={item.onClick}
                  key={`side_menu_item_onClick_${index}`}
                >
                  {item.label}
                </div>
              )}
              {item.component && (
                <div
                  className="py-2 pl-9 pr-2 block text-base font-semibold"
                  onClick={item.onClick}
                  key={`side_menu_item_component_${index}`}
                >
                  {item.component}
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  )
}

export default SideMenuItem
